import { render, staticRenderFns } from "./profileLinks.vue?vue&type=template&id=59c3237e&scoped=true&"
import script from "./profileLinks.vue?vue&type=script&lang=js&"
export * from "./profileLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c3237e",
  null
  
)

export default component.exports